module.exports = __webpack_public_path__ + "media/images/vp/icon.fb.red-9a24d817967f72509132f851e16fb3fb.png";